// extracted by mini-css-extract-plugin
module.exports = {"layout":"callout_layout__C_ZcH","graphic":"callout_graphic__MOP2z","content":"callout_content__mGAeP"};